import * as React from 'react';
import { connect } from 'react-redux';

// these are default values. They will be used if no Class properties are set
// default callback if nothing else is defined
const _swipeLeft = (event:any) => {};
// default callback if nothing else is defined
const _swipeRight = (event:any) => {};
// default callback if nothing else is defined
const _swipeUp = (event:any) => {};
// default callback if nothing else is defined
const _swipeDown = (event:any) => {};
// default callback if nothing else is defined
const _touchStart = (event:any, startX:number, startY:number) => {};
const _clickStart = (event:any, startX:number, startY:number) => {};
// default callback if nothing else is defined
const _touchEnd = (event:any, endX:number, startY:number) => {};
// default callback if nothing else is defined
const _touchMove = (event:any, offsetX:number, offsetY:number) => {};
const _mouseMove = (event:any, offsetX:number, offsetY:number) => {};
// default callback if nothing else is defined
const _swipe = (event:any, direction:string) => {};
// defines the minimum x offset between touch start and touch end
const _minX = 30;
// defines the maximum x offset between touch start and touch end
const _maxX = 40;
// defines the minimum y offset between touch start and touch end
const _minY = 50;
// defines the maximum y offset between touch start and touch end
const _maxY = 60;
// locks the x axis movement
const _lockXAxis = false;
// locks the y axis movement
const _lockYAxis = false;

// statics to have no or less typos
const LEFT:string = 'left';
const RIGHT:string = 'right';
const UP:string = 'up';
const DOWN:string = 'down';

// the interface is needed to set specific options if you call the swiper with options like:
// <Swiper touchStart={ ( event: any ) => {} } />
// if you dont have an interface for the props typescript will call an error
export interface Props {
    swipeLeft?      : Function
    swipeRight?     : Function
    touchStart?     : Function
    clickStart?     : Function
    touchEnd?       : Function
    touchMove?      : Function
    mouseMove?      : Function
    swipeUp?        : Function
    swipeDown?      : Function
    swipe?          : Function
    minX?           : number
    maxX?           : number
    minY?           : number
    maxY?           : number
    lockXAxis?      : boolean
    lockYAxis?      : boolean
    mouseLock       : boolean
}

// if you dont have an interface for the state typescript will call an error
export interface State {
    startTouchX   : number
    endTouchX     : number
    startTouchY   : number
    endTouchY     : number
    mouseLock     : boolean
}

class Swiper extends React.Component<Props, State> {

    constructor(props:any) {
        super(props);

        // set initial Swiper state
        this.state = {
            startTouchX: 0,
            endTouchX: 0,
            startTouchY: 0,
            endTouchY: 0,
            mouseLock: false,
        }
    }


    _onTouchStart(event:any, callback:Function):void {
        let  xPos = event.touches ? event.touches[0].clientX : event.clientX;
        let  yPos = event.touches ? event.touches[0].clientY : event.clientY;
        let mouse_move = true;

        this.setState({
            ...this.state,
            startTouchX: xPos,
            startTouchY: yPos,
            endTouchX: xPos,
            endTouchY: yPos,
            mouseLock: mouse_move,
        });

        // call the optional action/logic defined by the user
        callback(event, xPos, yPos);
    }

    _onTouchEnd(event:any, callback:Function):void {
        let direction = null;
        let mouse_move = false;

        const startTouchX = this.state.startTouchX;
        const endTouchX = this.state.endTouchX;
        const startTouchY = this.state.startTouchY;
        const endTouchY = this.state.endTouchY;

        const minX:number = this.props.minX || _minX;
        const maxX:number = this.props.maxX || _maxX;
        const minY:number = this.props.minY || _minY;
        const maxY:number = this.props.maxY || _maxY;

        const swipeRight:Function = this.props.swipeRight || _swipeRight;
        const swipeLeft:Function = this.props.swipeLeft || _swipeLeft;
        const swipeUp:Function = this.props.swipeUp || _swipeLeft;
        const swipeDown:Function = this.props.swipeDown || _swipeDown;
        const swipe:Function = this.props.swipe || _swipe;

        // if it is a horizontal swipe and check for for the swiped direction (left or right)
        if (checkForHorizontalSwipe(startTouchX, endTouchX, startTouchY, endTouchY, minX, maxY)) {
            if (endTouchX > startTouchX) {
                direction = RIGHT;
                swipeRight(event);
            } else {
                direction = LEFT;
                swipeLeft(event);
            }
        }
        // if it is no horizontal swipe check if it is a vertical and check for the swipe direction (up or down)
        else if (checkForVerticalSwipe(startTouchX, endTouchX, startTouchY, endTouchY, minY, maxX)) {
            if (endTouchY > startTouchY) {
                direction = UP;
                swipeUp(event);
            } else {
                direction = DOWN;
                swipeDown(event);
            }
        }

        //set state to default or untouched ;)
        this.setState({
            ...this.state,
            startTouchX: 0,
            endTouchX: 0,
            startTouchY: 0,
            endTouchY: 0,
            mouseLock: mouse_move,

        });

        // check if the swipe was successful (reached tollerances) and call the related callbacks
        if (direction) {
            // call the user specified swipe event
            swipe(event, direction);
            // call the optional action/logic defined by the user
            callback(event, endTouchX, endTouchY);
        }
    }

    _onTouchMove(event:any, callback:Function):void {

        let  xPos = event.touches ? event.touches[0].clientX : event.clientX;
        let  yPos = event.touches ? event.touches[0].clientY : event.clientY;


        // save the current touch position in endTouchX and endTouchY

        if(this.state.mouseLock){
            this.setState({
                ...this.state,
                endTouchX: xPos,
                endTouchY: yPos
            });
        }

        // call the optional action/logic defined by the user
        callback(event, calcOffset(this.state.startTouchX, xPos), calcOffset(this.state.endTouchY, yPos));
    }

    render() {
        const touchStart:Function = this.props.touchStart || _touchStart;
        const touchEnd:Function = this.props.touchEnd || _touchEnd;
        const touchMove:Function = this.props.touchMove || _touchMove;
        const mouseMove:Function = this.props.mouseMove || _mouseMove;

        const lockXAxis:boolean = this.props.lockXAxis;
        const lockYAxis:boolean = this.props.lockYAxis;

        const left:number = lockYAxis ? 0 : calcOffset(this.state.startTouchX, this.state.endTouchX);
        const top:number = lockXAxis ? 0 : calcOffset(this.state.endTouchY, this.state.startTouchY);

        return (
            <div
                className="swiper"
                style={{left: left, top: top}}
                onMouseDown={ ( event: any ) => { this._onTouchStart( event, touchStart ) } }
                onMouseUp={ ( event: any ) => { this._onTouchEnd( event, touchEnd ) } }
                onMouseMove={ ( event: any ) => { this._onTouchMove( event, mouseMove ) } }
                onTouchStart={ ( event: any ) => { this._onTouchStart( event, touchStart ) } }
                onTouchEnd={ ( event: any ) => { this._onTouchEnd( event, touchEnd ) } }
                onTouchMove={ ( event: any ) => { this._onTouchMove( event, touchMove ) } }
            >
                {this.props.children}
            </div>
        );
    }
}

// calculate a offset of two values
const calcOffset: any = (start: number, end: number) => end - start;

// checks if the swipe is a horizontal swipe. It also checks for the given tolerances (minX and maxY)
const checkForHorizontalSwipe: any = ( startTouchX: number, endTouchX: number, startTouchY: number, endTouchY: number, minX: number, maxY: number ) => {
  return ( ((endTouchX - minX > startTouchX) || (endTouchX + minX < startTouchX) )
    && ( (endTouchY < startTouchY + maxY) && (startTouchY > endTouchY - maxY) && (endTouchX > 0)) );
};

// checks if the swipe is a vertical swipe. It also checks for the given tolerances (minY and maxX)
const checkForVerticalSwipe: any = ( startTouchX: number, endTouchX: number, startTouchY: number, endTouchY: number, minY: number, maxX: number ) => {
  return ( ((endTouchY - minY > startTouchY) || (endTouchY + minY < startTouchY))
  && ((endTouchX < startTouchX + maxX) && (startTouchX > endTouchX - maxX) && (endTouchY > 0)) );
};

const mapStateToProps = ( state: any ) => ({});

export default connect(mapStateToProps)(Swiper) as any;